import React from 'react'

const LightbulbIcon = ({ className = '', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      {...props}
    >
      <defs>
        <radialGradient id="bulb-glow" cx="50%" cy="40%" r="55%">
          <stop offset="0%" stopColor="#FFFFFF" />
          <stop offset="35%" stopColor="#FFED7A" />
          <stop offset="100%" stopColor="#FFC200" />
        </radialGradient>
        <filter id="bulb-shadow" x="-30%" y="-30%" width="160%" height="160%">
          <feDropShadow dx="0" dy="0" stdDeviation="2" floodColor="#FFD54F" floodOpacity="0.5" />
        </filter>
      </defs>
      <path
        d="M10 2a5.5 5.5 0 0 0-3.5 9.74V13a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-1.26A5.5 5.5 0 0 0 10 2Z"
        fill="url(#bulb-glow)"
        filter="url(#bulb-shadow)"
      />
      <path
        d="M7.5 15.5h5M8.5 17.5h3"
        stroke="#FFC200"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default LightbulbIcon
